export default "__VITE_ASSET__5a772e88__"